import React from 'react';

export default function FwUploadIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-upload' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
